import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faTrash } from '@fortawesome/pro-duotone-svg-icons';
import { faGripLines } from '@fortawesome/pro-light-svg-icons';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SetTabById } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/tab-brick-behaviour/tab-brick-behaviour.actions';
import { BrickInstancesSelectors } from 'src/app/store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { IBrickDescription } from 'src/app/store/dashboard/brick-wall/brick-instances/brick-instances.state';
import {
   ChangeTabColorForTabBrick,
   ChangeTabIconForTabBrick,
   ChangeTabTitleForTabBrick,
   RemoveTabForTabBrick,
} from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/tab-brick-settings/tab-brick-settings.actions';
import { TabContentRemoteDto } from 'src/generated/swagger';
import { TabBrickSettingsState } from '../../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/tab-brick-settings/tab-brick-settings.state';

@Component({
   selector: 'samweb-tab-item-setting',
   templateUrl: './tab-item-setting.component.html',
   styleUrls: ['./tab-item-setting.component.scss'],
})
export class TabItemSettingComponent implements OnInit {
   public tabContent$: Observable<TabContentRemoteDto>;

   @Input()
   public tabId: string;

   @Input()
   public brickInstanceId: string;

   @Input()
   public collapsed = false;

   public dragIcon: IconDefinition = faGripLines;

   public removeTabIcon: IconDefinition = faTrash;
   public isRemoveTabAllowed$: Observable<boolean>;

   public tabContentBrickDescription$: Observable<IBrickDescription>;

   constructor(private store: Store) {}

   ngOnInit() {
      this.tabContent$ = this.store.select(TabBrickSettingsState.getTabContentForBrickInstanceIdFn).pipe(map((fn) => fn(this.brickInstanceId, this.tabId)));
      this.isRemoveTabAllowed$ = this.store.select(TabBrickSettingsState.getTabs).pipe(
         map((fn) => fn(this.brickInstanceId)),
         map((tabs) => tabs.length),
         map((tabCount) => tabCount > 1)
      );

      this.tabContentBrickDescription$ = this.tabContent$.pipe(
         switchMap((tabContent) =>
            this.store.select(BrickInstancesSelectors.brickDescriptionFn).pipe(map((fn) => fn(tabContent ? tabContent.brickInstanceId : null)))
         )
      );
   }

   tabTitleChanged(value: string) {
      this.store.dispatch(new ChangeTabTitleForTabBrick(this.brickInstanceId, this.tabId, value));
   }

   removeTab(tabBrickinstanceId: string) {
      this.store.dispatch(new RemoveTabForTabBrick(this.brickInstanceId, this.tabId, tabBrickinstanceId));
   }

   selectTab() {
      this.store.dispatch(new SetTabById(this.brickInstanceId, this.tabId));
   }

   tabColorChanged(value: string) {
      this.store.dispatch(new ChangeTabColorForTabBrick(this.brickInstanceId, this.tabId, value));
   }

   clearTabColor() {
      this.store.dispatch(new ChangeTabColorForTabBrick(this.brickInstanceId, this.tabId, null));
   }

   tabIconChanged(value: IconDefinition) {
      this.store.dispatch(new ChangeTabIconForTabBrick(this.brickInstanceId, this.tabId, value));
   }
}
